import React from 'react';

export function MediaList({
  media,
  onImageLoad,
}: {
  media?: string[] | null;
  onImageLoad?: (src: string) => void;
}) {
  if (!media || !media?.length) return null;

  return (
    <div className="grid grid-cols-3 gap-2 mt-2 w-full">
      {media.map((src, i) => (
        <div key={i} className="h-72 rounded-sm overflow-hidden">
          <img
            src={src}
            alt={`Portfolio sample ${i + 1}`}
            className="w-full h-full object-cover"
            onLoad={() => onImageLoad?.(src)}
            onError={() => onImageLoad?.(src)} // Count as loaded even if it fails
          />
        </div>
      ))}
    </div>
  );
}
